<template>
  <div>
    <v-row
      class="mt-5"
    >
      <v-col
        sm="12"
        md="12"
        lg="12"
        xl="6"
      >
        <section>
          <line-chart
            class="mb-5"
            :raw-data="players"
            :plot-options="{bar: {horizontal: false, borderRadius: 10, dataLabels: {position: 'center', orientation: 'vertical'}}}"
            :chart-value-keys="[ { key: 'UXPCSTD', type: 'bar', label: $t('card_title.total_distance') }, { key: 'UXPCSMYPM', label: 'm/min' } ]"
            x-value="last_name"
            y-value-prefix="player_stats."
            :data-labels="{enabled: true, enabledOnSeries: [0], formatter: function (val, {dataPointIndex}) {
              return labels.totalDist[dataPointIndex] !== undefined && labels.totalDist[dataPointIndex] !== null ? labels.totalDist[dataPointIndex] + '%' : ''
            }}"
            :markers="{size: 5}"
            :yaxis="[{ title: { text: $t('card_title.total_distance') }}, { title: { text: 'm/min' }, opposite: true } ]"
            :colors="['#008FFB','#00E396']"
            :xaxis="{
              labels: {
                rotate: -45
              },
              categories: players.map(p => p.first_name + ' ' + p.last_name),
              tickPlacement: 'between'
            }"
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <div class="subtitle-2 grey--text text--grey-100">
                  {{ $t('card_title.total_distance_and_m_min') }}
                </div>
              </v-card-title>
            </template>
          </line-chart>
        </section>
      </v-col>
      <v-col
        sm="12"
        md="12"
        lg="12"
        xl="6"
      >
        <section>
          <line-chart
            class="mb-5"
            :raw-data="players"
            :plot-options="{bar: {horizontal: false, borderRadius: 10, dataLabels: {position: 'center', orientation: 'vertical'}}}"
            :chart-value-keys="[ { key: 'CALETLDLHSR', label: $t('chart_legends.hsr_distance'), type: 'bar' }, { key: 'UXPCSEEF', label: $t('chart_legends.of_explosive_efforts') } ]"
            x-value="last_name"
            y-value-prefix="player_stats."
            :data-labels="{enabled: true, enabledOnSeries: [0], formatter: function (val, {dataPointIndex}) {
              return labels.totalHSR[dataPointIndex] !== undefined && labels.totalHSR[dataPointIndex] !== null ? labels.totalHSR[dataPointIndex] + '%' : ''
            }}"
            :markers="{size: 5}"
            :yaxis="[ { title: { text: $t('chart_legends.hsr_distance') }},{ title: { text: $t('chart_legends.explosive_efforts') }, opposite: true } ]"
            :xaxis="{
              labels: {
                rotate: -45
              },
              categories: players.map(p => p.first_name + ' ' + p.last_name),
              tickPlacement: 'between'
            }"
            :colors="[ '#FF4560', '#775DD0' ]"
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <div class="subtitle-2 grey--text text--grey-100">
                  {{ $t('card_title.high_speed_running_and_explosive_efforts') }}
                </div>
              </v-card-title>
            </template>
          </line-chart>
        </section>
      </v-col>
    </v-row>
    <v-row
      class="mt-3"
    >
      <v-col
        sm="12"
        md="12"
        lg="12"
        xl="6"
      >
        <section>
          <line-chart
            class="mb-5"
            :raw-data="players"
            :chart-value-keys="[ { key: 'UXINTS', type: 'bar', label: $t('gps_variables.intensity') }, { key: 'UXVOL', label: $t('gps_variables.volume') } ]"
            :plot-options="{bar: {horizontal: false, borderRadius: 10}}"
            x-value="last_name"
            y-value-prefix="player_stats."
            :markers="{size: 5}"
            :yaxis="[ { title: { text: $t('gps_variables.volume') }, opposite: true}, { title: { text: $t('gps_variables.intensity') } } ]"
            :xaxis="{
              labels: {
                rotate: -45
              },
              categories: players.map(p => p.first_name + ' ' + p.last_name),
              tickPlacement: 'between'
            }"
            :colors="[ '#FEB019', '#008FFB' ]"
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <div class="subtitle-2 grey--text text--grey-100">
                  {{ $t('card_title.volume_and_intensity') }}
                </div>
              </v-card-title>
            </template>
          </line-chart>
        </section>
      </v-col>
      <v-col
        sm="12"
        md="12"
        lg="12"
        xl="6"
      >
        <section>
          <line-chart
            class="mb-5"
            :plot-options="{bar: {horizontal: false, borderRadius: 10, dataLabels: {position: 'center', orientation: 'vertical'}}}"
            :stacked="true"
            :raw-data="players"
            :chart-value-keys="[ { key: 'CACGCSMXV', type: 'bar', label: $t('chart_legends.maximum_velocity_km_h') }, { key: 'UXMAXVELALL', type: 'line', label: $t('chart_legends.maximum_velocity_all_time') } ]"
            x-value="last_name"
            :markers="{size:[0,6]}"
            :data-labels="{enabled: true, enabledOnSeries: [0], formatter: function (val, {dataPointIndex}) {
              return labels.velocity[dataPointIndex] !== undefined && labels.velocity[dataPointIndex] !== null ? labels.velocity[dataPointIndex] + '%' : ''
            }}"
            :stroke="{show: false}"
            y-value-prefix="player_stats."
            :yaxis="[ { title: { text: $t('chart_legends.velocity') }, max: 40, tickAmount: 4} ]"
            :xaxis="{
              labels: {
                rotate: -45
              },
              categories: players.map(p => p.first_name + ' ' + p.last_name),
              tickPlacement: 'between'
            }"
            :colors="[ '#c42b59', '#df7595' ]"
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <div class="subtitle-2 grey--text text--grey-100">
                  {{ $t('card_title.max_velocity_vs_all_time') }}
                </div>
              </v-card-title>
            </template>
          </line-chart>
        </section>
      </v-col>
    </v-row>
    <v-row class="mt-3">
      <v-col>
        <section>
          <line-chart
            class="mb-5"
            :raw-data="players"
            :chart-value-keys="[ { key: 'CAPGCSDCB13EG2', type: 'bar', label: $t('chart_legends.deceleration_less_-4') },
                                 { key: 'UXDCB13', type: 'bar', label: $t('chart_legends.deceleration_less_-3') },
                                 { key: 'UXDCB14', type: 'bar', label: $t('chart_legends.deceleration_less_-2') },
                                 { key: 'UXACB58', type: 'bar', label: $t('chart_legends.accelerations_more_2') },
                                 { key: 'UXACB68', type: 'bar', label: $t('chart_legends.accelerations_more_3') },
                                 { key: 'CAPGCSACB13EG2', type: 'bar', label: $t('chart_legends.accelerations_more_4') }, ]"
            x-value="last_name"
            y-value-prefix="player_stats."
            :xaxis="{
              labels: {
                rotate: -45
              },
              categories: players.map(p => p.first_name + ' ' + p.last_name),
              tickPlacement: 'between'
            }"
            :colors="[ '#ff0000', '#ff6666', '#ff9999', '#1affb2', '#00e396', '#00b377']"
            :fill="{ opacity: [0.5, 0.5, 0.5, 0.5, 0.5, 0.5]}"
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <div class="subtitle-2 grey--text text--grey-100">
                  {{ $t('card_title.accelerations_and_decelerations') }}
                </div>
              </v-card-title>
            </template>
          </line-chart>
        </section>
      </v-col>
    </v-row>
    <v-card>
      <v-card-title
        class="pt-5 ml-4"
      >
        <v-row>
          <v-col cols="auto">
            <div class="d-inline-flex align-center">
              <v-sheet
                max-width="10"
                class="rounded-circle mr-1"
                elevation="12"
                height="10"
                width="10"
                style="background-color: #008FFB"
              />
              <div class="body-1 grey--text text--grey-100">
                {{ $t('gps_variables.speed_0_7') }}
              </div>
            </div>
          </v-col>
          <v-col cols="auto">
            <div class="d-inline-flex align-center">
              <v-sheet
                max-width="10"
                class="rounded-circle mr-1"
                elevation="12"
                height="10"
                width="10"
                style="background-color: #F4A641"
              />
              <div class="body-1 grey--text text--grey-100">
                {{ $t('gps_variables.speed_7_14.4') }}
              </div>
            </div>
          </v-col>
          <v-col cols="auto">
            <div class="d-inline-flex align-center">
              <v-sheet
                max-width="10"
                class="rounded-circle mr-1"
                elevation="12"
                height="10"
                width="10"
                style="background-color: #F9E03B"
              />
              <div class="body-1 grey--text text--grey-100">
                {{ $t('gps_variables.speed_14.4_19.8') }}
              </div>
            </div>
          </v-col>
          <v-col cols="auto">
            <div class="d-inline-flex align-center">
              <v-sheet
                max-width="10"
                class="rounded-circle mr-1"
                elevation="12"
                height="10"
                width="10"
                style="background-color: #86CC8E"
              />
              <div class="body-1 grey--text text--grey-100">
                {{ $t('gps_variables.spr_m') }}
              </div>
            </div>
          </v-col>
          <v-col cols="auto">
            <div class="d-inline-flex align-center">
              <v-sheet
                max-width="10"
                class="rounded-circle mr-1"
                elevation="12"
                height="10"
                width="10"
                style="background-color: #DD644C"
              />
              <div class="body-1 grey--text text--grey-100">
                {{ $t('gps_variables.sprint') }}
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-title>
      <v-row>
        <v-col
          v-for="player in players"
          :key="player.id"
          xl="3"
        >
          <pie-chart
            class="fill-height"
            height="250"
            :series="[
              player.player_stats['CACTCSVB1TD'] || 0,
              player.player_stats['CACTCSVB2TD'] || 0,
              player.player_stats['CACTCSVB3TD'] || 0,
              player.player_stats['CALETLDLHSR'] || 0,
              player.player_stats['CALETLDLSP'] || 0]"
            :hide-labels="true"
            :colors="[ '#008FFB', '#F4A641', '#F9E03B', '#86CC8E', '#DD644C']"
            :labels="[$t('gps_variables.speed_0_7'),$t('gps_variables.speed_7_14.4'),$t('gps_variables.speed_14.4_19.8'),$t('gps_variables.hsr'),$t('gps_variables.sprint')]"
          >
            <template v-slot:header>
              <v-card-title class="pa-6 ml-3">
                <v-row
                  dense
                  align="center"
                >
                  <v-col class="text-no-wrap">
                    <div class="body-1 grey--text text--grey-100">
                      {{ player.first_name + ' ' + player.last_name }}
                    </div>
                  </v-col>
                </v-row>
              </v-card-title>
            </template>
          </pie-chart>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart'
import PieChart from '@/components/charts/PieChart.vue'

export default {
  name: 'PerformanceGraphs',
  components: { PieChart, LineChart },
  props: {
    players: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    labels: {}
  }),
  created() {
    this.players.map(player => {
      if (!player.player_stats) return player
      player.player_stats.UXMAXVELALL = Math.round((player.player_stats?.CACGCSMXV / (player.player_stats?.UXMAXVELREF / 100)) * 100) / 100
      return player
    })

    this.labels.velocity = this.players.map(player => player.player_stats.UXMAXVELREF)
    this.labels.totalDist = this.players.map(player => player.player_stats.UXPCSTD_GALL)
    this.labels.totalHSR = this.players.map(player => player.player_stats.CALETLDLHSR_GALL)
  }
}
</script>

<style scoped>

</style>
